import { Config } from '../types/index.js';

export const DEFAULT_CONFIG: Config = {
  templates: {},
};

export const CONFIG_FILE_NAME = '.zhrc.json';

